import { Message } from '@/types/messages';
import { cn } from '@/lib/utils';
import { BookingRequestMessage } from './BookingRequestMessage';
import { format } from 'date-fns';
import { BookingSystemMessage } from '@/types/messages';

export interface MessageBubbleProps {
  message: Message;
  isOwnMessage: boolean;
  conversationId: string;
}

export function MessageBubble({ message, isOwnMessage, conversationId }: MessageBubbleProps) {
  // Handle system messages (like booking requests)
  if (message.type === 'system' && 'readBy' in message && 
      typeof message.content === 'object' && 
      'type' in message.content && 
      'bookingId' in message.content) {
    return <BookingRequestMessage message={message as unknown as BookingSystemMessage} conversationId={conversationId} />;
  }

  // Handle text messages
  return (
    <div className={cn(
      "flex w-full mt-2 space-x-3 max-w-2xl",
      isOwnMessage ? "ml-auto justify-end" : "mr-auto justify-start"
    )}>
      <div className={cn(
        "relative p-3 rounded-lg",
        isOwnMessage 
          ? "bg-blue-600 text-white" 
          : "bg-gray-800 text-gray-200"
      )}>
        <p>{typeof message.content === 'string' ? message.content : JSON.stringify(message.content)}</p>
      </div>
    </div>
  );
} 